let IdNamePair = require('./IdNamePair');

module.exports = class MaturityLevel extends IdNamePair {};
